import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ShopItem } from '../../models/shop/shop-item.model';
import { ApiShopService } from './api/api-shop.service';
import { ApplicationsService } from '../applications/applications.service';

@Injectable({
  providedIn: 'root'
})
export class ShopService {

  public itemsLoadedSubject = new Subject<void>();
  public items: ShopItem[] = [];
  public isLoaded: boolean = false;

  constructor(
    private apiShopService: ApiShopService,
    private applicationsService: ApplicationsService
  ) {
    this.applicationsService.applicationIdSelectedSubject.subscribe(() => {
      this.loadItems();
    });

    if (this.applicationsService.applicationIdSelected !== 0) {
      this.loadItems();
    }
  }

  refresh(): void {
    this.loadItems();
  }

  private loadItems(): void {
    this.isLoaded = false;
    this.apiShopService.getItems().then(
      response => {
        this.items = response.results;
        this.isLoaded = true;
        this.itemsLoadedSubject.next();
      },
      error => { console.error('Failed to load shop items', error); }
    );
  }
}
